import { render, staticRenderFns } from "./choose-dpMent.vue?vue&type=template&id=d5fec626&"
import script from "./choose-dpMent.vue?vue&type=script&lang=js&"
export * from "./choose-dpMent.vue?vue&type=script&lang=js&"
import style0 from "./choose-dpMent.vue?vue&type=style&index=0&id=d5fec626&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports